import Swiper, { Navigation } from 'swiper';

const arrow = `<svg width="32" height="32" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 1.00098C8.16344 1.00098 0.999998 8.16442 0.999999 17.001C0.999999 25.8375 8.16344 33.001 17 33.001C25.8366 33.001 33 25.8375 33 17.001C33 8.16442 25.8366 1.00098 17 1.00098Z" stroke="#141430" stroke-miterlimit="10"/>
<path d="M17.833 22.001L22.833 17.001L17.833 12.001" stroke="#141430" stroke-width="1.5" stroke-linecap="round"/>
<path d="M22 17.001L10.5 17.001" stroke="#141430" stroke-width="1.5" stroke-linecap="round"/>
</svg>
`;

export const patternTestimonialsCards = () => {
  const cardCount = $(
    '.pattern-testimonials-cards .pattern-testimonials-item-card'
  ).length;

  // Create Swiper container for testimonials if there are more than three
  if (cardCount > 3) {
    document
      .querySelectorAll('.pattern-testimonials-item-card')
      .forEach((card) => {
        const cardContainer = document.createElement('div');
        cardContainer.classList.add('card-container');
        document
          .querySelector(
            '.pattern-testimonials-cards .wp-block-group__inner-container'
          )
          .appendChild(cardContainer);
        cardContainer.appendChild(card);
      });

    $('.pattern-testimonials-cards')
      .removeClass('wp-block-group')
      .addClass('swiper')
      .children()
      .removeClass('wp-block-group__inner-container')
      .addClass('swiper-wrapper')
      .children('.card-container')
      .removeClass('wp-block-group')
      .addClass('swiper-slide')
      .children()
      .children()
      .unwrap();

    $('.pattern-testimonials-cards').append(
      `<button class="swiper-button-prev">${arrow}</button>`
    );
    $('.pattern-testimonials-cards').append(
      `<button class="swiper-button-next">${arrow}</button>`
    );

    const swiper = new Swiper('.pattern-testimonials-cards', {
      loop: true,
      centeredSlides: true,

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      modules: [Navigation],
    });
  }
};
